<template>
  <div class="add-new-address">
    <header class="shiping-header">
      <span class="back-icon" @click="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
          <g fill="#FFF" fill-rule="evenodd">
            <path
              d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            />
            <path
              d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            />
          </g>
        </svg>
      </span>
      <div class="head-title">
        <span v-if="$route.query.addressId">पता बदलें</span>
        <span v-else>नया पता जोड़ें</span>
      </div>
    </header>
    <form action>
      <div class="field">
        <label for>पूरा नाम *</label>
        <input type="text" placeholder="यहाँ अपना पूरा नाम लिखे" v-model="getAddress.personName" />
      </div>

      <div class="field">
        <label for>
          मोबाइल नंबर *
          <span>(इसपे कूरियर वाला आपसे संपर्क करेगा)</span>
        </label>
        <input
          type="number"
          placeholder="अपना 10 अंको वाला मोबाइल नंबर "
          v-model="getAddress.contactNumber"
        />
      </div>
      <div class="field">
        <label for>पिन कोड *</label>
        <input
          type="number"
          placeholder="6 अंकीय पिन कोड डाले "
          v-model="getAddress.zipcode"
          v-on:keyup="getPincodeDetails"
        />
      </div>


      <div class="field">
        <label for>पूरा पता *</label>
        <input
          type="text"
          placeholder="फ्लैट, घर का नंबर, बिल्डिंग, कंपनी, अपार्टमेंट "
          v-model="getAddress.address"
        />
      </div>

      
      <div class="field">
        <label for>पोस्ट ऑफिस</label>
        <input type="text" placeholder="पोस्ट ऑफिस " v-model="getAddress.postOfficeName" />
      </div>

      <div class="field">
        <label for>शहर *</label>
        <input type="text" placeholder="क़स्बा/शहर " v-model="getAddress.city" />
      </div>

      <div class="field">
        <label for>राज्य *</label>
        <select v-model="getAddress.state" class="form-control cstm_field" required>
          <option v-for="(state,index) in countryState" :value="state" :key="index">{{state}}</option>
        </select>
      </div>

      <div class="field">
        <label for>लैंडमार्क</label>
        <input type="text" placeholder="लैंडमांक (वैकल्पिक)" v-model="getAddress.landMark" />
      </div>
      <span class="submit-btn" @click="editAddress()" v-if="$route.query.addressId">Save Address</span>
      <span class="submit-btn" @click="addAddress()" v-else>Add Address</span>
    </form>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
        <img src="../../assets/images/loader.gif" alt="loader" />
      </div>
  </div>
</template>

<script>
import ApiCaller from "../../utils/apicaller";
import constant from "../../utils/constant";
import CustomToaster from "../Common/CustomToaster";
export default {
  name: "AddNewAddress",
  components: { CustomToaster },
  data() {
    return {
      toasterData: {},
      getAddress: {},
      isValidDetail: false,
      countryState: constant.CountryState,
      loading: false
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getAddressById() {
      ApiCaller(
        constant.ADDRESS_URL,
        "getAddressesByAddressId/" + this.$route.query.addressId,
        "get"
      ).then(data => {
        this.getAddress = data.data;
      });
    },
    validateFields() {
      const obj = this.getAddress;
      if (
        !obj.address ||
        !obj.zipcode ||
        !obj.state ||
        !obj.city ||
        !obj.contactNumber ||
        !obj.personName
      ) {
        this.toasterData = {
          msg: "कृपया जारी रखने के लिए सभी फ़ील्ड ठीक से भरें",
          color: "red"
        };
        this.isValidDetail = true;
        return false;
      } else {
         if (obj.personName.length <= 3) {         
          this.toasterData = {
            msg: "कृपया मान्य नाम नंबर दर्ज करें !",
            color: "red"
          };
           this.isValidDetail = true;
          return false;
        }
        if (obj.contactNumber.length != 10) {
          this.isValidDetail = true;
          this.toasterData = {
            msg: "कृपया मान्य मोबाइल नंबर दर्ज करें !",
            color: "red"
          };
          return false;
        }
        if (obj.address.length <= 4) {          
          this.toasterData = {
            msg: "कृपया मान्य पता नंबर दर्ज करें !",
            color: "red"
          };
          this.isValidDetail = true;
          return false;
        }
        if (obj.zipcode.length != 6) {          
          this.toasterData = {
            msg: "कृपया मान्य पिन कोड दर्ज करें ",
            color: "red"
          };
          this.isValidDetail = true;
          return false;
        }
        return true;
      }
    },
    getPincodeDetails() {
      if (this.getAddress.zipcode.length > 5) {
        this.loading = true;
        const userPincode = this.getAddress.zipcode;
        this.$store
          .dispatch({
            type: "getPincodeDetails",
            payload: userPincode
          })
          .then(data => {
            this.loading = false;
            if (data.data) {               
              this.getAddress.zipcode = data.data.pincode;
              this.getAddress.city = data.data.city;
              this.getAddress.state = data.data.state;
              this.getAddress.postOfficeName = data.data.postOfficeName;
            }
          })
          .catch(err => {
            this.loading = false;
          });
      }
    },
    addAddress() {
      if (this.validateFields()) {
        this.loading = true
        ApiCaller(constant.ADDRESS_URL,"/addAddress/v2" ,"post" ,  this.getAddress ).then(data => {
          this.getAddress = data.data;
          this.loading = false
          this.$router.go(-1);
        });
      }
    },
    editAddress() {
      if (this.validateFields()) {
        ApiCaller(
          constant.ADDRESS_URL,
          "editAddress",
          "post",
          this.getAddress
        ).then(data => {
          this.getAddress = data.data;
          this.$router.go(-1);
        });
      }
    }
  },
  mounted() {
    if (this.$route.query.addressId) {
      this.getAddressById();
    }
  }
};
</script>
